// extracted by mini-css-extract-plugin
module.exports = {"mapHeaderInput":"MapSection_mapHeaderInput__1cdub","mapSizeInput":"MapSection_mapSizeInput__1vyI9","textFieldContainer":"MapSection_textFieldContainer__2Q4q5"};